module.exports = __webpack_public_path__ + "assets/img/6-xs.699e8b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/picture/why/6-xs.jpg
// module id = fJ+v
// module chunks = 1